module.exports = __webpack_public_path__ + "static/media/icon_home_logo.6c447b111e9fc0862df382e7214ac6ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_home_logo.png
// module id = 2649
// module chunks = 1